import { HttpRequest } from './HttpRequest'

export const GetSalesLists = async () => {
    try { 
        const response = await HttpRequest().get(`/sales/lists`)
        if (response.data.message === 'OK') {
            const result: any[] = response.data.responseData
            return result.filter(f => f.code !== "" && f.name.trim() !== "")
        }
        return []
    } catch (error: any) {
        return []
    }
}